var BaseViews = require('../base');
var Spinner = require('treeline-shared-components/spinner');

require('./cart-payment-challenge/cart-payment-challenge.scss');

var CartPaymentChallenge = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-payment-challenge',
    template: require('./cart-payment-challenge/cart-payment-challenge.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                challengeData: null,
                _appChannel: null
            }
        );
    },
    ui: {
      formChallenge: '.fmcy-form-challenge',
      formChallengeIframe: '.fmcy-form-challenge-iframe'
    },
    regions: {
      spinnerRegion: '.spinner-region'
    },
    onRender: function() {
      var self = this;
      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
      this.challengeIframe = $('<iframe>')
      .attr('height',$(window).height())
      .attr('width',$(window).width())
      .appendTo(this.ui.formChallenge);

      this.challengeIframe.ready(function() {
          var body = self.challengeIframe.contents().find('body');
          self.challengeForm = $('<form>', {
              'action': self.options.challengeData.data.challengeUrl,
              'target': '_self',
              'method': 'POST' 
          }).append(jQuery('<input>', {
              'name': 'creq',
              'value': self.options.challengeData.data.challengeData,
              'type': 'hidden'
          })).appendTo(body);
          self.challengeForm.submit();
          
      });
      this._renderSpinner();
      this._onWindowResize();
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    _renderSpinner: function () {
      this._spinner = new Spinner();
      this.spinnerRegion.show(this._spinner);
      this._spinner.setMessage('Authenticating...');
    },
    _onWindowResize: function (event) {
      var magicBuffer = 132;
      var minHeight = $(window).height() - magicBuffer;
      this.$el.css('minHeight', $(window).height());
      if (this.challengeIframe) {
        this.challengeIframe.attr('height', minHeight);
        this.challengeIframe.attr('width', $(window).width());
      }

      this.ui.formChallenge.css('minHeight', $(window).height());
      this.ui.formChallenge.css('minWidth', $(window).width());
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(self);
    }
});

module.exports = CartPaymentChallenge;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-payment-challenge.js
 **/